import { ApolloProvider } from '@apollo/client';
import { Box, Text } from '@chakra-ui/react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { apolloClient } from '@lon/mathnation-suit/configs';
import { isLocalEnv } from './duck';
import { Footer, LoginButton, PasswordReset } from './components';

const App: React.FC = () => {
  const location = useLocation();

  return (
    <ApolloProvider client={apolloClient}>
      <Box
        maxH="100vh"
        h="100vh"
        backgroundImage={`url(${
          isLocalEnv() ? '/' : 'login/'
        }assets/images/background.jpg)`}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        p="200px 20px 0"
        position="relative"
        overflow="hidden"
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Text as="h1" fontSize="5xl" fontWeight="bold" color="white">
          POWERING MATH ACHIEVEMENT
        </Text>

        <Text color="rgba(255, 255, 255, 0.6)" fontSize="lg" textAlign="center">
          Comprehensive, proven math resources <br /> for 6-8th Grade Math,
          Algebra 1, Geometry, Algebra 2 and beyond.
        </Text>

        <LoginButton />

        {location.pathname.includes('reset-password') && <PasswordReset />}

        <Box
          background="linear-gradient(to bottom right, transparent 0%, transparent 50%, white 50%, white 100%)"
          position="absolute"
          bottom="0"
          right="0"
          width="100%"
          height="100px"
          zIndex="2"
        />
        <Box
          backgroundImage={`url(${
            isLocalEnv() ? '/' : 'login/'
          }assets/images/people.png)`}
          backgroundRepeat="no-repeat"
          backgroundSize="cover"
          width="700px"
          height="470px"
          mt="auto"
        />
      </Box>
      <Footer />
    </ApolloProvider>
  );
};

export default App;
